import type { FC } from 'react';
import { FormSection } from '@patternfly/react-core/dist/dynamic/components/Form';
import { TextInputTypes } from '@patternfly/react-core/dist/dynamic/components/TextInput';
import { useTranslation } from 'react-i18next';
import { InputField } from '@console/shared';

const ImageSection: FC = () => {
  const { t } = useTranslation();

  return (
    <FormSection>
      <InputField
        type={TextInputTypes.text}
        name="advancedOptions.image"
        label={t('webterminal-plugin~Image')}
        helpText={t('webterminal-plugin~Set custom image for the terminal.')}
      />
    </FormSection>
  );
};

export default ImageSection;
